// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1KCMB","errorLogs":"EditorFooter_errorLogs__1RmDs"};